import { render, staticRenderFns } from "./CreateContact.vue?vue&type=template&id=38893604&scoped=true&"
import script from "./CreateContact.vue?vue&type=script&lang=ts&"
export * from "./CreateContact.vue?vue&type=script&lang=ts&"
import style0 from "./CreateContact.vue?vue&type=style&index=0&id=38893604&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38893604",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VForm,VIcon,VListItem,VListItemAction,VSelect})
